import { PastProvider } from './models';

export const getCopy = (provider?: PastProvider) => {
    return provider && provider?.id > 0 ? getProviderCopy(provider) : getGenericCopy();
};

const getProviderCopy = (provider: PastProvider) => {
    return (
        `Hey! I just used a great Tandem provider, ${provider.first_name}, and you should try them out too! ` +
        `Tandem is a completely free childcare, pet care, housecleaning (and more!) connection service that provides pre-vetted providers to families. ` +
        `Sign up and request ${provider.first_name} using this link. You'll get $20 off your first job!`
    );
};

const getGenericCopy = () => {
    return (
        `Hey! You should check out Tandem. Tandem is a completely free childcare, pet care, housecleaning (and more!) connection service. ` +
        `It provides background checked care providers to families based on their unique needs and preferences. And the best part? You get $20 off ` +
        `your first job!`
    );
};

export const getOneTimeGiftCardCopy = () => {
    return (
        `I've chosen you as the recipient of my $40 Tandem gift card! Whether you're in need of child care, pet care, house cleaning, ` +
        `or other services in your home, Tandem has got you covered! ` +
        `Tandem is a completely free connection platform that provides background checked care providers to families based on their unique needs and preferences. Check it out today!`
    );
};
